import { Utils } from "./utils";
const root = document.documentElement;
const body = document.body;
const navigation = document.querySelector("nav");
let subNav = null;
let navbarCollapse = null;
let navShown = false;
// Add an "!" before a classname to remove the class on scroll rather than add it
const navAddClasslist = ["show-border"];
if (navigation != null) {
    const navigationContents = navigation.children[0].children;
    for (var i = 0; i < navigationContents.length; i++) {
        var child = navigationContents[i];
        if (child.classList.contains("navbar-collapse")) {
            navbarCollapse = child;
        }
    }
}
export class Navigation {
    /**
     * Navigation functionality to run on load.
     */
    NavigationOnLoad() {
        if (navigation != null) {
            Utils.copyHeight(navigation, root, "--nav-height");
            Utils.copyHeight(navigation, body, "--nav-height");
            subNav = navigation.querySelector(".nav-secondary");
            if (subNav != null) {
                Utils.copyHeight(subNav, root, "--sub-nav-height");
                Utils.copyHeight(subNav, body, "--sub-nav-height");
            }
            const scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
            navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, scrollTop);
        }
    }
    /**
     * Navigation functionality to run on page resize.
     */
    NavigationOnResize() {
        if (navigation != null) {
            if (navbarCollapse != null) {
                if (!navbarCollapse.classList.contains("show")) {
                    Utils.copyHeight(navigation, root, "--nav-height");
                    Utils.copyHeight(navigation, body, "--nav-height");
                    if (subNav !== null) {
                        Utils.copyHeight(subNav, root, "--sub-nav-height");
                        Utils.copyHeight(subNav, body, "--sub-nav-height");
                    }
                }
            }
            else {
                Utils.copyHeight(navigation, root, "--nav-height");
                Utils.copyHeight(navigation, body, "--nav-height");
                if (subNav !== null) {
                    Utils.copyHeight(subNav, root, "--sub-nav-height");
                    Utils.copyHeight(subNav, body, "--sub-nav-height");
                }
            }
            navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, (document.documentElement || document.body.parentNode || document.body).scrollTop);
        }
    }
    /**
     * Navigation functionality to run on page scroll.
     */
    NavigationOnScroll() {
        const scrollTop = (document.documentElement || document.body.parentNode || document.body).scrollTop;
        if (scrollTop == 0) {
            navShown = false;
        }
        if (!navShown) {
            if (navigation != null) {
                navShown = Utils.updateClassesOnScroll(navigation, root, "--nav-height", navAddClasslist, null, scrollTop);
            }
        }
    }
}
